import React, { Fragment, useMemo, useState, useContext } from 'react'
import { useUser } from '@auth0/nextjs-auth0/client'
import Link from 'next/link'
import classNames from 'classnames'
import { storageWrapper } from '@saatva-bits/pattern-library.utils.storage'
import { OrderContext } from '@/store/orderProvider'
import { auth0 } from '@/config/globals'
import FacebookIcon from '@/components/Icons/facebook'
import GoogleIcon from '@/components/Icons/google'
import AppleIcon from '@/components/Icons/apple'

import styles from './styles.module.scss'

const AuthButtons = () => {
    const { isLoading, setLoading } = useContext(OrderContext)
    const { user } = useUser()
    const signUpAction = auth0.SIGNUP.action
    const loginAction = auth0.LOGIN.action
    const signUpLabel = auth0.SIGNUP.label
    const loginLabel = auth0.LOGIN.label

    const [activeTab, setActiveTab] = useState(signUpAction)

    const toggleTab = () =>
        setActiveTab((prev) => (prev === signUpAction ? loginAction : signUpAction))

    const actionLabel = useMemo(
        () => (activeTab === signUpAction ? signUpLabel : loginLabel),
        [activeTab]
    )

    const facebookLoginUrl = useMemo(
        () => `${auth0.facebookLoginUrl}&action=${activeTab}`,
        [activeTab]
    )

    const googleLoginUrl = useMemo(() => `${auth0.googleLoginUrl}&action=${activeTab}`, [activeTab])

    const appleLoginUrl = useMemo(() => `${auth0.appleLoginUrl}&action=${activeTab}`, [activeTab])

    const disabledLinkClassName = useMemo(() => {
        return classNames({ [styles.disabledLink]: isLoading })
    }, [isLoading])

    const authStarted = () => {
        setLoading(true)
        storageWrapper().setItem(auth0.localStorageReturnPath, auth0.myOrdersUrl, 'local')
    }

    return (
        <div className={styles.container}>
            <div className={styles.or}>Or</div>

            {!user && (
                <Fragment>
                    <div className={classNames(styles.tabsContainer, activeTab)}>
                        <button
                            onClick={toggleTab}
                            type="button"
                            className={classNames(styles.tabButton, {
                                active: activeTab === signUpAction
                            })}
                            disabled={isLoading}
                        >
                            Sign up
                        </button>
                        <button
                            onClick={toggleTab}
                            type="button"
                            className={classNames(styles.tabButton, {
                                active: activeTab === loginAction
                            })}
                            disabled={isLoading}
                        >
                            Login
                        </button>
                    </div>

                    <div className={styles.buttons}>
                        <Link
                            className={classNames(styles.facebookButton, disabledLinkClassName)}
                            href={facebookLoginUrl}
                            onClick={authStarted}
                        >
                            <FacebookIcon />
                            {actionLabel} with Facebook
                        </Link>
                        <Link
                            className={classNames(styles.googleButton, disabledLinkClassName)}
                            href={googleLoginUrl}
                            onClick={authStarted}
                        >
                            <GoogleIcon />
                            {actionLabel} with Google
                        </Link>
                        <Link
                            className={classNames(styles.appleButton, disabledLinkClassName)}
                            href={appleLoginUrl}
                            onClick={authStarted}
                        >
                            <AppleIcon />
                            {actionLabel} with Apple
                        </Link>
                    </div>
                </Fragment>
            )}
        </div>
    )
}

export default AuthButtons
